import { Component, OnInit, Input } from "@angular/core";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { EdpModalService } from "@edp-components/edp-modal";
import { Pack } from "@edp-components/edp-pack";
import { ContaCertaService } from "@edp-services/conta-certa.service";
import { Contract } from "@edp-components/edp-contract";
import { ISimulate } from "@edp-models/conta-certa.model";
import { Discount } from "@edp-components/edp-pack-discount";

@Component({
    selector: "edp-pack-conta-certa-modal",
    templateUrl: "./edp-pack-conta-certa-modal.component.html",
    styleUrls: ["./edp-pack-conta-certa-modal.component.scss"],
})
export class EdpPackContaCertaModalComponent implements OnInit {
    @Input() public data: {pack: Pack, contract: Contract, discount: Discount};
    public isSubmited = false;
    public form: FormGroup;
    public contaCertaSimulation$: Observable<ISimulate>;
    public sum: number;
    public contaCertaValue: number;

    constructor(
        private formBuilder: FormBuilder,
        private edpModalService: EdpModalService,
        public contaCertaService: ContaCertaService,
    ) {}

    ngOnInit() {
        this.contaCertaSimulation$ = this.contaCertaService.simulate({
            args: {
                contract_id: this.data.contract.ContractId,
            },
        });

        this.contaCertaSimulation$.subscribe((simulation: ISimulate) => {
            if (simulation.success) {
                this.form = this.formBuilder.group({
                    value: [
                        simulation.amount,
                        [
                            Validators.required,
                            Validators.min(simulation.minimum),
                            Validators.max(simulation.maximum)
                        ]
                    ],
                });
                this.changed();
            }
        });
    }

    public changed() {
        this.contaCertaValue = Number(this.form.value.value);
        this.sum = Number(this.form.value.value) + Number(this.data.pack.discount) ;
    }

    public close(): void {
        this.isSubmited = true;
        const hasError: boolean = this.form.invalid;

        if (!hasError) {
            this.edpModalService.close(this.contaCertaValue);
        }
    }

    public dismiss(): void {
        this.edpModalService.dismiss(false);
    }
}
